import { Box, FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import React from 'react';
import ClassroomStudent from '../classroom-student/ClassroomStudent';
import DroppableClassroomStudent from '../droppable-classroom-student/DroppableClassroomStudent';
import { ClassroomStudentStatus, ClassroomStudent as IClassroomStudent, Position as IPosition, Layout } from '../types';

export interface EditablePositionProps {
  assignedStudent?: IClassroomStudent;
  layouts: Layout[];
  listItems: IClassroomStudent[];
  onAssign: (userId?: string) => void;
  onChangeLayout: (layoutId: string) => void;
  position: IPosition;
}

const EditablePosition = ({
  assignedStudent,
  layouts,
  listItems,
  onAssign,
  onChangeLayout,
  position,
}: EditablePositionProps) => {
  return (
    <>
      <Typography component="h3" variant="h6" mb={2}>
        {position.name}
      </Typography>
      <Box position="relative" display={{ xs: 'none', sm: 'block' }}>
        <DroppableClassroomStudent onAssign={onAssign} positionId={position.id} assignedStudent={assignedStudent} />
      </Box>
      <FormControl fullWidth margin="normal" sx={{ display: { sm: 'none' } }}>
        <InputLabel required>Student</InputLabel>
        <Select
          label="Student"
          name="student"
          onChange={event => onAssign(event.target.value)}
          required
          value={position.userId ?? ''}
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {listItems.map(student => (
            <MenuItem key={student.id} value={student.id}>
              <ClassroomStudent
                {...student}
                joined={student.status === ClassroomStudentStatus.Joined}
                sx={{ height: '23px', p: 0 }}
              />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl fullWidth margin="normal">
        <InputLabel>Layout</InputLabel>
        <Select
          label="Layout"
          name="layout"
          onChange={event => onChangeLayout(event.target.value)}
          value={position.layoutId ?? ''}
        >
          {layouts.map(layout => (
            <MenuItem key={layout.id} value={layout.id}>
              {layout.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
};

export default EditablePosition;
